import React from "react";

const Java_equals = () => {
  return (
    <div>
      <h1>Java equals</h1>
      <p>This page provides explanations, examples, and common use-cases for Java equals in Java.</p>
    </div>
  );
};

export default Java_equals;
